"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _getVideoOutputName = _interopRequireDefault(require("@devsta/get-video-output-name"));

var _commonReact = require("@devsta/common-react");

var _AssetDetails = _interopRequireDefault(require("../../AssetDetails"));

require("../styles/_delete-confirmation-modal.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var DEFAULT_WARNINGS = ['All share links will be inaccessible', 'All video comments and history will be archived', 'All asset references will be removed'];

var DeleteConfirmationModal = function DeleteConfirmationModal(_ref) {
  var hideModal = _ref.hideModal,
      output = _ref.output,
      deleteOutput = _ref.deleteOutput,
      onComplete = _ref.onComplete;

  if (!output) {
    return null;
  }

  var _ref2 = output || {},
      _ref2$versions = _ref2.versions,
      versions = _ref2$versions === void 0 ? [] : _ref2$versions,
      video = _ref2.video,
      latestVersion = _ref2.latestVersion;

  var outputName = output ? (0, _getVideoOutputName.default)(output, video.name) : '';

  var _ref3 = versions.find(function (_ref4) {
    var versionNumber = _ref4.versionNumber;
    return versionNumber === latestVersion;
  }) || {},
      assetId = _ref3.assetId;

  return (/*#__PURE__*/_react.default.createElement(_commonReact.DeleteConfirmationModal, {
      onDelete: deleteOutput,
      objectId: output ? output.outputId : void 0,
      hideModal: hideModal,
      onComplete: onComplete,
      title: "Delete Video",
      subTitle: "Are you sure you want to delete this video?",
      warnings: output && output.isMaster ? [].concat(DEFAULT_WARNINGS, ['As this is the master video, your video brief and any other outputs will also be removed']) : DEFAULT_WARNINGS
    }, /*#__PURE__*/_react.default.createElement(_AssetDetails.default, {
      assetId: assetId,
      outputName: outputName
    }))
  );
};

var _default = (0, _react.memo)(DeleteConfirmationModal);

exports.default = _default;